module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/60402ee4ea5c76b0d47183b82dcc1b1b.png";